export const decodeJwt = (token) => {
  try {
    if (!token) {
      throw new Error('Token is empty or undefined');
    }

    // Split token into parts (header, payload, signature)
    const parts = token.split('.');
    if (parts.length !== 3) {
      throw new Error(`Invalid JWT format: Expected 3 parts, got ${parts.length}`);
    }

    // Decode the payload (second part)
    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

    // Add padding if necessary
    const paddedBase64 = base64 + '='.repeat((4 - (base64.length % 4)) % 4);

    const jsonPayload = decodeURIComponent(
      atob(paddedBase64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join(''),
    );

    const parsedPayload = JSON.parse(jsonPayload);
    return parsedPayload;
  } catch (error) {
    return null;
  }
};
